import * as React from 'react';
import {Property} from 'csstype';
import styled from 'styled-components';
import {Margins, Size} from '../types';
import {CleanArrowBottomAxis} from './axes/CleanArrowBottomAxis';
import {AvatarPoint} from './elements/AvatarPoint';

const DEF_MARGINS: Margins = {left: 0, right: 0, bottom: 0, top: 0};

interface ChartProps {
  margins?: Margins;
  svgDimensions: Size;
  className?: string;
  bordered?: boolean;
  gradients?: [
    {id: string; direction: string; startOpacity: number; endOpacity: number; color: Property.Color}
  ];
  placeholder?: React.Component;
}

/**
 * An element to hide/wrap the SVG.
 *
 * @returns Section/SVG in order to nest child chart elements inside
 */
export class Chart extends React.Component<ChartProps> {
  private readonly svg: React.RefObject<SVGSVGElement>;

  constructor(props: ChartProps) {
    super(props);
    this.svg = React.createRef();
  }

  render() {
    const {
      margins = DEF_MARGINS,
      svgDimensions,
      bordered = false,
      children,
      gradients,
      placeholder,
    } = this.props;

    return (
      <>
        <StyledChartContainer className={this.props.className}>
          {placeholder}
          <svg viewBox={'0 0 ' + svgDimensions.width + ' ' + svgDimensions.height} ref={this.svg}>
            <defs>
              {gradients?.map(g => (
                <Gradient
                  id={g.id}
                  key={g.id}
                  startOpacity={g.startOpacity}
                  endOpacity={g.endOpacity}
                  color={g.color}
                />
              ))}
              {CleanArrowBottomAxis.getDefinitions()}
              {AvatarPoint.getDefinitions()}
            </defs>
            {bordered && (
              <rect
                className="graph-border"
                x={margins.left}
                y={margins.top}
                width={svgDimensions.width - margins.left - margins.right}
                height={svgDimensions.height - margins.top - margins.bottom}
              />
            )}
            {children}
          </svg>
        </StyledChartContainer>
      </>
    );
  }
}

class Gradient extends React.Component<{
  id: string;
  startOpacity: number;
  endOpacity: number;
  color: string;
}> {
  render() {
    const {id, startOpacity, endOpacity, color} = this.props;
    return (
      <linearGradient id={id} x1={'0%'} x2={'0%'} y1={'100%'} y2={'0%'}>
        <stop offset={'0%'} stopColor={color} stopOpacity={endOpacity} />
        <stop offset={'100%'} stopColor={color} stopOpacity={startOpacity} />
      </linearGradient>
    );
  }
}

const StyledChartContainer = styled.section`
  position: relative;
  display: inline-block;
  width: 100%;
  vertical-align: top;

  svg {
    overflow: visible !important;
    display: inline-block;
  }
`;
